import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UsuariosService } from 'app/services/module-config/users/usuarios.service';
//import { PAGINAS_DISPONIBLES } from '../../../core/config/permisos-paginas';

interface MenuLink {
  tipo?: 'enlace';
  nombre: string;
  ruta: string;
  permiso?: string;
  permisos?: string[];
  accesoAutenticado?: boolean;
  soloMovil?: boolean;
  conExternalId?: boolean;
}

interface MenuSubgroup {
  tipo: 'subgrupo';
  nombre: string;
  clave: string;
  items: MenuEntry[];
}

type MenuEntry = MenuLink | MenuSubgroup;

interface MenuGroup {
  categoria: string;
  clave: string;
  items: MenuEntry[];
}

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  @Input() menuVisible: boolean = true;
  @Output() menuToggle = new EventEmitter<boolean>();
  submenuAbierto: Record<string, boolean> = {};
  subgrupoAbierto: Record<string, boolean> = {};
  menu: MenuGroup[] = [];
  employeeExternalId: string | null = null;

  private readonly menuCompleto: MenuGroup[] = [
    {
      categoria: '🧩 Kyara AI',
      clave: 'kyara-ai',
      items: [
        {
          nombre: 'Asistentes IA',
          ruta: '/ai/kyara',
        },
      ],
    },
    {
      categoria: 'Tareas ZIVO',
      clave: 'tasklist',
      items: [{ nombre: 'Tareas asignadas', ruta: '/tasklist/mis-tareas' }],
    },
    {
      categoria: 'Productos',
      clave: 'productos',
      items: [
        {
          nombre: 'Mis Requerimientos',
          ruta: '/productos/ingreso-rq/filtrado-bodega/traking',
          permiso: 'productos/ingreso-rq/tracking',
          soloMovil: true,
        },
        { nombre: 'Catálogo de Productos', ruta: '/productos/catalogo' },
        { nombre: 'Requerimientos', ruta: '/productos/ingreso-rq' },
        { nombre: 'Compras', ruta: '/productos/compras' },
        { nombre: 'Inventario de Productos', ruta: '/productos/inventario' },
        {
          nombre: 'Transferencias de Productos',
          ruta: '/productos/transferencias',
        },
      ],
    },
    {
      categoria: 'Solicitudes de Pagos',
      clave: 'pagos',
      items: [
        { nombre: 'Dashboard', ruta: '/pagos/dashboard' },
        {nombre:'Seguimiento Financiero de Pagos',ruta:'/pagos/seguimiento-financiero',permiso:'pagos/seguimiento-financiero/ver'},
        { nombre: 'Configuraciones', ruta: '/pagos/configuraciones' },
        { nombre: 'Proveedores', ruta: '/pagos/proveedores' },
        { nombre: 'Solicitud de Pagos', ruta: '/pagos/pagos-proveedores' },
        { nombre: 'Aprobaciones de Pagos', ruta: '/pagos/aprobaciones-pagos' },
      ],
    },
    {
      categoria: 'Mantenimientos',
      clave: 'mantenimientos',
      items: [
        {
          nombre: 'Mantenimientos',
          ruta: '/mantenimientos/mantenimientos-km-hr/mantenimientos-km-hr-formulario',
        },
        {
          nombre: 'Vigencia de equipos',
          ruta: '/mantenimientos/mantenimientos-km-hr/vigencias',
          permisos: [
            'mantenimientos/mantenimientos-km-hr/vigencias',
            'mantenimientos/mantenimientos-km-hr/editar',
          ],
        },
        {
          nombre: 'Repositorio documental',
          ruta: '/mantenimientos/repositorio-documental',
          permisos: [
            'mantenimientos/repositorio-documental',
            'mantenimientos/repositorio-documental/vehiculos',
            'mantenimientos/repositorio-documental/tipos-documentales',
          ],
        },
        { nombre: 'Materiales', ruta: '/ssa/materiales' },
      ],
    },
    {
      categoria: 'Control de Proyectos',
      clave: 'project-control',
      items: [
        { nombre: 'Proyectos', ruta: '/project-control/projects' },
        {
          nombre: 'Dashboard de Proyectos',
          ruta: '/project-control/dashboard',
          permiso: 'project-control/dashboard',
        },
        { nombre: 'Matriz Iperc', ruta: '/project-control/matriz-iperc/kyara-ai' },
      ],
    },
    {
      categoria: 'Fatiga',
      clave: 'fatigue',
      items: [
        { nombre: 'Mi fatiga', ruta: '/fatigue/user', accesoAutenticado: true },
        { nombre: 'Administración', ruta: '/fatigue/admin' },
        { nombre: 'Configuración', ruta: '/fatigue/configuration' },
      ],
    },
    {
      categoria: 'SSA',
      clave: 'ssa',
      items: [
        {
          nombre: 'Gestión SSA',
          ruta: '/ssa',
          permisos: [
            'ssa',
            'ssa/epp',
            'ssa/productos-epp',
            'ssa/epp-productos',
            'ssa/materiales',
            'ssa/examenes-medicos',
            'ssa/clinicas',
            'ssa/vacunas',
            'ssa/certificados-medicos',
          ],
        },
        {
          nombre: 'Control de Seguridad',
          ruta: '/ssa/control-seguridad',
          accesoAutenticado: true,
          permisos: [
            'ssa/control-seguridad',
            'ssa/control-seguridad/distribucion-diaria',
            'ssa/control-seguridad/inicio-seguro',
            'ssa/control-seguridad/evidencias-documentales',
            'ssa/control-seguridad/gestion-diaria',
            'ssa/control-seguridad/registro',
            'ssa/control-seguridad/charlas',
            'ssa/control-seguridad/iperc',
            'ssa/control-seguridad/dashboard',
            'ssa/control-seguridad/responsables',
            'ssa/control-seguridad/configuracion',
          ],
        },
      ],
    },
    {
      categoria: 'Servicios',
      clave: 'servicios',
      items: [{ nombre: 'Logística y pasajes', ruta: '/servicios' }],
    },
    {
      categoria: 'Alimentación',
      clave: 'alimentacion',
      items: [
        {
          nombre: 'Mis reservas',
          ruta: '/alimentacion/reservar',
          permiso: 'alimentacion/reservar',
        },
        {
          nombre: 'Gestión y reservas',
          ruta: '/alimentacion/gestion',
          permisos: [
            'alimentacion/gestion',
            'alimentacion/reservar-terceros',
            'alimentacion/reportes',
          ],
        },
      ],
    },
    {
      categoria: 'Servicios Misceláneos',
      clave: 'servicios-miscelaneos',
      items: [
        { nombre: 'Clientes', ruta: '/servicios-miscelaneos/clientes' },
        {
          nombre: 'Cotizaciones',
          ruta: '/servicios-miscelaneos/solicitudes-contratacion',
        },
        { nombre: 'KPIS', ruta: '/servicios-miscelaneos/kpis' },
      ],
    },
    {
      categoria: 'Control de Colaboradores',
      clave: 'colaboradores',
      items: [
        { nombre: 'Calificaciones', ruta: '/colaboradores/calificaciones' },
      ],
    },
    {
      categoria: 'ITE',
      clave: 'ite',
      items: [
        {
          nombre: 'Gestión ITE',
          ruta: '/ite',
          permisos: [
            'ite',
            'ite/dashboard',
            'ite/almacenamiento-temporal',
            'ite/inventario',
            'ite/entregas-recepciones',
            'ite/configuracion',
            'ite/ingresos-computadoras',
            'ite/correos-corporativos',
          ],
        },
      ],
    },
    {
      categoria: 'Administración de Obras',
      clave: 'administracion-obras',
      items: [
        {
          nombre: 'Gestión de obra',
          ruta: '/administracion-obras',
          permisos: [
            'administracion-obras',
            'administracion-obras/distribucion-diaria',
            'administracion-obras/nuevos-ingresos',
            'administracion-obras/personal',
            'administracion-obras/asistencia',
            'administracion-obras/eventos-internos',
            'administracion-obras/entradas-salidas',
            'administracion-obras/pasajes',
            'administracion-obras/desvinculacion',
            'recursos-humanos/contratacion/ingresos-nuevos',
            'recursos-humanos/personal/empleados/consulta',
            'recursos-humanos/attendance',
            'recursos-humanos/eventos',
            'recursos-humanos/eventos/eventos-empleado',
            'recursos-humanos/shift-schedule',
            'recursos-humanos/desvinculacion',
          ],
        },
      ],
    },
    {
      categoria: 'Recursos Humanos',
      clave: 'recursos-humanos',
      items: [
        { nombre: 'Personal', ruta: '/recursos-humanos/personal' },
        { nombre: 'Digitación desde Drive', ruta: '/recursos-humanos/drive-documentos' },
        { nombre: 'Contratación', ruta: '/recursos-humanos/contratacion' },
        { nombre: 'Asistencia', ruta: '/recursos-humanos/attendance' },
        {
          tipo: 'subgrupo',
          nombre: 'Rol de Pagos',
          clave: '/recursos-humanos/payroll',
          items: [
            { nombre: 'Gestión de Nómina', ruta: '/recursos-humanos/payroll' },
            {
              nombre: 'Comprobantes de Pago',
              ruta: '/recursos-humanos/pay-comprobants',
            },
          ],
        },
        {
          nombre: 'Entrada y Salida Empleado',
          ruta: '/recursos-humanos/shift-schedule',
        },
        { nombre: 'Eventos', ruta: '/recursos-humanos/eventos' },
        { nombre: 'Procesos', ruta: '/recursos-humanos/procesos' },
        { nombre: 'Desvinculación', ruta: '/recursos-humanos/desvinculacion' },
        { nombre: 'Préstamos', ruta: '/recursos-humanos/prestamos' },
        {
          tipo: 'subgrupo',
          nombre: 'Configuración y catálogos',
          clave: 'rrhh-configuracion-catalogos',
          items: [
            { nombre: 'Cargos', ruta: '/recursos-humanos/cargos' },
            {
              nombre: 'Categorías y Eventos de Asistencia',
              ruta: '/recursos-humanos/attendance-categories-events',
            },
            {
              nombre: 'Conceptos de Nómina',
              ruta: '/recursos-humanos/payroll-concepts',
            },
            { nombre: 'Feriados', ruta: '/recursos-humanos/feriados' },
            { nombre: 'Proyección', ruta: '/recursos-humanos/projections' },
          ],
        },
      ],
    },
    {
      categoria: 'Repositorio',
      clave: 'repositorio',
      items: [
        {
          nombre: 'Documentos Electritel',
          ruta: '/repositorio/documentos-electritel',
        },
      ],
    },
    {
      categoria: 'Configuraciones',
      clave: 'configuraciones',
      items: [
        {
          nombre: 'Aprobaciones',
          ruta: '/configuraciones/approval-settings',
        },
        { nombre: 'Configuraciones', ruta: '/configuraciones/settings' },
        { nombre: 'Avatar asistente', ruta: '/configuraciones/avatar-asistente', accesoAutenticado: true },
        {
          nombre: 'Consentimientos',
          ruta: '/configuraciones/politicas-consentimientos',
        },
        { nombre: 'Permisos y accesos', ruta: '/configuraciones/access-control', permisos: ['configuraciones/access-control', 'configuraciones/permisos'] },
        {
          nombre: 'Nómina de Eventos',
          ruta: '/configuraciones/nomina-eventos',
        },
        { nombre: 'Tema de pantalla', ruta: '/configuraciones/tema' },
        { nombre: 'Usuarios', ruta: '/configuraciones/usuarios-lista' },
      ],
    },
    {
      categoria: 'Formularios',
      clave: 'formularios',
      items: [
        { nombre: 'Apto', ruta: '/formularios/apto' },
        {
          nombre: 'Cotizacion de Servicios',
          ruta: '/formularios/solicitudes-contratacion',
        },
        {
          nombre: 'Contratación Empleado',
          ruta: '/formularios/contratacion',
        },
        {
          nombre: 'Desvinculación Empleado',
          ruta: '/formularios/desvinculacion',
        },
        {
          nombre: 'Eventos Empleado',
          ruta: '/formularios/eventos-empleado',
        },
        {
          nombre: 'Solicitud de eventos',
          ruta: '/formularios/solicitud-eventos',
          permisos: ['formularios/solicitud-eventos'],
        },
        {
          nombre: 'Entrada y Salida Empleado',
          ruta: '/formularios/entrada-salida-empleado',
        },
        {
          nombre: 'Solicitud de hospedaje',
          ruta: '/formularios/hospedaje',
          permiso: 'formularios/hospedaje',
        },
        {
          nombre: 'Entrega y recepción de equipos',
          ruta: '/formularios/ite/entrega-recepcion',
          permiso: 'formularios/ite/entrega-recepcion',
        },
      ],
    },
    {
      categoria: 'Tareas Equipo',
      clave: 'tasks',
      items: [
        { nombre: 'Centro de tareas', ruta: '/tasks' },
        { nombre: 'Dashboard', ruta: '/tasks/dashboard' },
        { nombre: 'Tablero de tareas', ruta: '/tasks/tasks' },
        { nombre: 'Proyectos', ruta: '/tasks/projects' },
        { nombre: 'Equipos', ruta: '/tasks/teams' },
        { nombre: 'Sitios de trabajo', ruta: '/tasks/sites' },
      ],
    },
    {
      categoria: 'Mi equipo',
      clave: 'teams',
      items: [
        { nombre: 'Equipo', ruta: '/teams/my-team' },
        { nombre: 'Mi distribución de equipo', ruta: '/teams/my-team/distribucion', permiso: 'teams/my-team/distribucion' },
        {
          tipo: 'subgrupo',
          nombre: 'Configuración',
          clave: 'teams-my-team-configuracion',
          items: [
            { nombre: 'Responsables por proyecto', ruta: '/teams/my-team/configuracion/responsables', permiso: 'teams/my-team/configuracion/responsables' },
          ],
        },
        { nombre: 'Asistencia', ruta: '/teams/my-team/asistencia' },
        { nombre: 'Biométrico', ruta: '/teams/my-team/biometrico' },
      ],
    },
    {
      categoria: 'Tickets',
      clave: 'tickets',
      items: [{ nombre: 'Tickets', ruta: '/tickets' }],
    },
  ];

  constructor(
    private authService: AuthService,
    private router: Router,
    private userService: UsuariosService,
  ) {}

  ngOnInit(): void {
    this.filtrarMenuPorPermisos();
    this.refrescarPermisos();
    this.cargarEmpleado();
  }

  private refrescarPermisos(): void {
    this.authService.getPermisosBackend().subscribe({
      next: (permisos) => {
        this.authService.setPermisos(permisos || []);
        this.filtrarMenuPorPermisos();
      },
      error: () => {
        // Mantener los permisos locales si no es posible refrescarlos.
      },
    });
  }

  cargarEmpleado() {
    this.userService.getEmployeeByUsuario().subscribe({
      next: (employee) => {
        this.employeeExternalId = employee?.external_id || null;
        this.filtrarMenuPorPermisos();
      },
      error: () => {
        this.employeeExternalId = null;
        this.filtrarMenuPorPermisos();
      },
    });
  }

  filtrarMenuPorPermisos(): void {
    const permisosUsuario: string[] = this.authService.getPermisos();
    this.menu = this.menuCompleto
      .map((grupo) => {
        const itemsFiltrados = this.filtrarItems(grupo.items, permisosUsuario);
        return itemsFiltrados.length ? { ...grupo, items: itemsFiltrados } : null;
      })
      .filter((grupo): grupo is MenuGroup => grupo !== null);
  }

  private filtrarItems(
    items: MenuEntry[],
    permisosUsuario: string[],
  ): MenuEntry[] {
    return items.reduce<MenuEntry[]>((permitidos, item) => {
      if (this.esSubgrupo(item)) {
        const hijosPermitidos = this.filtrarItems(item.items, permisosUsuario);
        if (hijosPermitidos.length > 0) {
          permitidos.push({ ...item, items: hijosPermitidos });
        }
        return permitidos;
      }

      const rutaSinSlash = item.ruta.startsWith('/')
        ? item.ruta.slice(1)
        : item.ruta;
      if (this.authService.getUsuarioDesdeToken()?.secondary_company && !['recursos-humanos/attendance','configuraciones/usuarios-lista','configuraciones/access-control'].includes(rutaSinSlash)) return permitidos;
      const permisoRequerido = item.permiso || rutaSinSlash;
      const permisosRequeridos = item.permisos || [permisoRequerido];

      if (
        item.accesoAutenticado === true ||
        permisosRequeridos.some((requerido) =>
          permisosUsuario.some((permiso) => {
            const exigePermisoExacto =
              requerido === 'recursos-humanos/payroll' ||
              requerido === 'recursos-humanos/payroll-concepts' ||
              requerido === 'configuraciones/permisos' ||
              requerido === 'configuraciones/access-control' ||
              requerido === 'teams/my-team/configuracion/responsables';
            return exigePermisoExacto
              ? permiso === requerido
              : permiso.startsWith(requerido);
          }),
        )
      ) {
        permitidos.push(item);
      }

      return permitidos;
    }, []);
  }

  toggleMenu() {
    this.menuVisible = !this.menuVisible;
    this.menuToggle.emit(this.menuVisible);
  }

  toggleSubmenu(categoria: string): void {
    this.submenuAbierto[categoria] = !this.submenuAbierto[categoria];
  }

  toggleSubgrupo(clave: string): void {
    const estabaAbierto = !!this.subgrupoAbierto[clave];
    this.subgrupoAbierto = {};
    if (!estabaAbierto) {
      this.subgrupoAbierto[clave] = true;
    }
  }

  esSubgrupo(item: MenuEntry): item is MenuSubgroup {
    return item.tipo === 'subgrupo';
  }

  esEnlace(item: MenuEntry): item is MenuLink {
    return !this.esSubgrupo(item);
  }

  estaActivo(item: MenuLink): boolean {
    return this.router.isActive(this.router.parseUrl(item.ruta), {
      paths: item.ruta === '/ssa' ? 'exact' : 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }

  contieneRutaActiva(item: MenuSubgroup): boolean {
    return this.hayRutaActiva(item.items);
  }

  hayRutaActiva(items: MenuEntry[]): boolean {
    return items.some((hijo) =>
      this.esSubgrupo(hijo)
        ? this.contieneRutaActiva(hijo)
        : this.estaActivo(hijo),
    );
  }

  contarAccesos(items: MenuEntry[]): number {
    return items.reduce(
      (total, item) =>
        total + (this.esSubgrupo(item) ? this.contarAccesos(item.items) : 1),
      0,
    );
  }

  navegar(item: MenuLink): void {
    if (item.conExternalId && this.employeeExternalId) {
      this.router.navigate([item.ruta], {
        queryParams: { externalId: this.employeeExternalId },
      });
      return;
    }
    this.router.navigate([item.ruta]);
  }

  cerrarSesion(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
